import type { IconProps } from '../types/IconProps.ts';
export const Grid3x3Plus: IconProps = {
    name: 'Grid3x3Plus',
    children: [
        `<path d="M12 21H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v8M9 3v18M15 3v12M3 9h18M3 15h12M19 16v6M16 19h6" />`,
    ]
};